import type { DorfHelferTypeEnum } from '@/features/posts/types/dorfHelferType';

// The generated API types customAttributes values as `object`, so a string
// enum value cannot be assigned without going through `unknown`. Isolating the
// unavoidable cast here keeps the mutation hooks free of inline casts.
export const toSpecialPostCustomAttributes = (
  dorfHelferType: DorfHelferTypeEnum
): { [key: string]: object } => ({
  dorfHelferType: dorfHelferType as unknown as object
});
